import React from 'react';
import ReactDOM from 'react-dom';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${props => props.$transparent ? 'transparent' : 'rgba(0, 0, 0, 0.4)'};
  z-index: 99999; /* Increased z-index for safety */
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: ${props => props.$transparent ? 'none' : 'blur(4px)'};
  pointer-events: auto; /* Always block interactions */
`;


const LoadingOverlay = ({ message, transparent = false }) => {
  const { t } = useTranslation();

  // Use provided message, or fallback to localized 'loading'
  const displayMessage = message || t('loading');

  return ReactDOM.createPortal(
    <Overlay $transparent={transparent}>
      <Container style={transparent ? { boxShadow: '0 4px 15px rgba(0,0,0,0.1)', border: '1px solid #eee' } : {}}>
        <Spinner />
        <Message>{displayMessage}</Message>
      </Container>
    </Overlay>,
    document.body
  );
};

const Container = styled.div`
  background: white;
  padding: 32px 48px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  min-width: 200px;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 16px;
`;

const Message = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: center;
`;



export default LoadingOverlay;
